<template>
  <div id="default-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document" v-bind:style="'width:' + width">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{title}}</h4>
        </div>
        <div class="modal-body">
           <slot></slot>
          <!-- <iframe style="width: 100% !important; height: 600px !important;" :src="urlIframe"></iframe> -->
        </div>
        <div class="modal-footer">
          <button aria-label="Fechar" type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalDefault",
  props: ["title", "width"],
  data() {
    return {
      ticketBill: {
        cli_codigo: 1,
        crc_cupomnf: 2,
        crc_serienf: 3,
        crr_parcela: 4
      }
    };
  }, computed: {
      urlIframe : function(){
        return '/Financeiro/duplicata/'+ this.ticketBill.cli_codigo +'/'+ this.ticketBill.crc_cupomnf +'/'+ this.ticketBill.crc_serienf +'/'+ this.ticketBill.crr_parcela;
      }
  },
};
</script>